import React from 'react';
import Layout from '../components/layout/Layout';

const DisclaimerPage = () => {
  return (
    <Layout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Disclaimer</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. General Information</h2>
          <p className="text-gray-600 mb-6">
            The information provided on the STEAM-IE website is for general informational and educational 
            purposes only. While we strive to keep the information accurate and up-to-date, we make no 
            representations or warranties of any kind about the completeness, accuracy, reliability, or 
            availability of the information.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Educational Content</h2>
          <p className="text-gray-600 mb-6">
            Our educational materials and programs are designed to supplement, not replace, formal education. 
            Results may vary based on individual effort, prior knowledge, and dedication. We do not guarantee 
            specific outcomes or career advancement from our programs.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Product Safety</h2>
          <p className="text-gray-600 mb-6">
            STEAM-IE kits contain electronic components that should be used under adult supervision for 
            children under 12. Users are responsible for following safety guidelines provided with each kit. 
            STEAM-IE is not liable for injuries resulting from improper use of products.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. External Links</h2>
          <p className="text-gray-600 mb-6">
            Our website may contain links to external websites. We have no control over the content and 
            nature of these sites and are not responsible for their content or privacy practices.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Certifications</h2>
          <p className="text-gray-600 mb-6">
            STEAM-IE certifications represent completion of our programs and assessment of skills within 
            our framework. Recognition of these certifications by employers or educational institutions is 
            at their discretion. We continuously work to enhance the value and recognition of our certifications.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Technical Issues</h2>
          <p className="text-gray-600 mb-6">
            We strive to maintain website availability but cannot guarantee uninterrupted access. We are not 
            liable for any loss or damage arising from temporary unavailability of our services due to technical 
            issues beyond our control.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Testimonials</h2>
          <p className="text-gray-600 mb-6">
            Testimonials and success stories on our website represent individual experiences. Results are not 
            typical and may vary. Past performance does not guarantee future results.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
          <p className="text-gray-600 mb-6">
            To the maximum extent permitted by law, STEAM-IE shall not be liable for any direct, indirect, 
            incidental, special, or consequential damages resulting from the use or inability to use our 
            services or products.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact</h2>
          <p className="text-gray-600 mb-6">
            If you have any questions about this disclaimer:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777<br />
            Address: #101,102 ARG Shopping Complex, Jaipur Road, Ajmer, Rajasthan 305001
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default DisclaimerPage;
